import React, { useState } from 'react';
import { connect }            from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  actions as securityIncidentActions
} from '../../../ducks/securityIncidents/securityIncident.index';
import { Modal, Button, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import {Formik} from 'formik';
import * as yup from 'yup';
import {getCommTypeId} from '../SecurityIncidentHelpers';
import { useTranslation } from 'react-i18next';
/* ========= PACKAGE IMPORTS ========= */

const schema = yup.object().shape({
  status: yup.string().required(),
  description: yup.string().required(),
});

const mapStateToProps = () => ({
});
const mapDispatchToProps =  (dispatch) => {
  const combinedActionCreators = {
    requestCreateComm :  securityIncidentActions.requestCreateComm,
  };

  return bindActionCreators(combinedActionCreators, dispatch);
};

const CreateCommModal = ({requestCreateComm, sec_id, comm_types}) => {
  const { t } = useTranslation(["translation"]);
  const [commType, setCommType] = useState('');
  const [status, setStatus] = useState('');
  const [description, setDescription] = useState('');

  let styles = {
    error         :  {
      color       :  'red',
    },
    buttonError   :  {
      color       :  'red',
      marginLeft  :  '5px',
    },
    buttonRight   : {
      width       : '8rem',
      margin      : '1rem'
    },
    buttonLeft: {
      width       : '8rem',
      margin      : '1rem auto 1rem 1rem',
      float       : 'left'
    }
  }
  const [modalIsOpen,setIsOpen] = useState(false);
  const [showConfirmation,setShowConfirmation] = useState(false);
  const openModal = () => {
    setIsOpen(true);
  }
  const closeModal = () => {
    setIsOpen(false);
  }

  const resetValues = () => {
    setDescription('');
    setStatus('');
    setCommType('');
  }

  return (
    <div style={{'marginLeft': 'auto', 'marginTop': 'auto'}}>
      {/* Overlay Tooltip for button */}
      <OverlayTrigger
        key='left'
        placement='left'
        overlay=
        {
          <Tooltip id={`tooltip-left`}>Creates a new Comm</Tooltip>
        }
      >
        <Button  className="data-cy-create-comm-modal-button" variant="primary" onClick={openModal}>Create Comm</Button>
      </OverlayTrigger>
      
      <Modal show={modalIsOpen} onHide={closeModal} className="data-cy-create-comm-modal">
      <Formik   
          enableReinitialize
          validationSchema={schema}
          onSubmit={(values, {resetForm}) => {
            requestCreateComm(values);
            setShowConfirmation(false);
            closeModal();
            resetForm();
            resetValues();
          }}
          initialValues={{
            sec_id: sec_id,
            description: description,
            status: status,
            comm_type: getCommTypeId(commType, comm_types).toString(),
            is_hidden: 'N',
          }}
        >
        {({
          handleSubmit,
          handleBlur,
          errors,
          touched,
        }) => 
        (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Create Comm</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <Form.Group>
                  <div style={{display: 'flex'}}>
                    <div style={{'marginRight': 'auto', 'height': 'unset', 'width': '70%'}}>
                      <Form.Label>Comm Type</Form.Label>     
                      <Form.Control style={{height: 'unset'}} as="select" value={commType} onChange={e => setCommType(e.target.value)}>
                        {comm_types.map(({id, display_name, internal_name}) => {
                          return (
                            <option key={id} value={internal_name}>{display_name}</option>
                          )
                          })
                        }                      
                      </Form.Control>
                    </div>
                  </div>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    type="textarea"
                    as="textarea"
                    className="data-cy-create-comm-modal-description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    onBlur={handleBlur}
                    name="description"></Form.Control>
                    {errors.description && touched.description ? (
                      <div style={{color: 'red'}}>{errors.description}</div>
                    ) : null}
                </Form.Group>
                <Form.Group>
                  <Form.Label>Status</Form.Label>
                  <Form.Control
                    type="textarea"
                    as="textarea"
                    className="data-cy-create-comm-modal-title"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    onBlur={handleBlur}
                    name="status"></Form.Control>
                    {errors.status && touched.status ? (
                      <div style={{color: 'red'}}>{errors.status}</div>
                    ) : null}
                </Form.Group>
              </div>
            </Modal.Body>
             
            
            <Modal.Footer>
              <div style={{display: 'contents'}}>
                <Button variant="secondary" onClick={closeModal} className="data-cy-create-comm-modal-close" style={styles.buttonLeft}>Cancel</Button>
                <Button style={styles.buttonRight} className="data-cy-create-comm-modal-ok" type="submit">Submit</Button>
              </div>
            </Modal.Footer>
          </Form>
        )}
        </Formik>

      </Modal>
    </div>
  );
}

export default connect(mapStateToProps,mapDispatchToProps)(CreateCommModal);